import { CartContext, CountContext, OrderContext } from "./MyContext";
import React, {useCallback, useContext, useMemo, useState} from "react";

//todo: функция для добавления и удаления товара из корзины
//fixme: протестировать
function OrderProvider({ children }) {
    let cartData = useContext(CartContext);
    const { priceAmount, setPriceAmount, counter, setCounter, setItemCount , itemCount } = useContext(CountContext);

    const plusTypeCount = useCallback((id, count) => {
        const index = cartData.findIndex(o => o.id === id)
        cartData[index].count = (count + 1);
        setCounter(counter + 1);
        setPriceAmount(priceAmount + cartData[index].price)

    },[counter])

    const minusTypeCount = useCallback(( id, count) => {
        const index = cartData.findIndex(o => o.id === id)
        if( count === 0){
            cartData[index].count = 0;

        } else {
        cartData[index].count = (count - 1);
        setCounter(counter - 1);
        setPriceAmount(priceAmount - cartData[index].price)
        }
    },[counter])

    // Clean cart Function
    const cleanCart = useCallback(() =>{
        const lengthData = cartData.length
        cartData.splice(0, lengthData)
        setPriceAmount(0);
        setCounter(0);
        setItemCount(0)
        console.log(cartData)
    }, [itemCount])


    //найти объект в массиве по которому кликнули
    //удалить объект из массива по которому кликнули
    // add and delter product Variant Func
    const delData = useCallback((id) =>{
        const index = cartData.findIndex(o => o.id === id)
        setCounter(counter - cartData[index].count);
        setPriceAmount(priceAmount - (cartData[index].price * cartData[index].count))
        cartData.splice(index, 1)
        setItemCount(cartData.length)
        console.log(priceAmount)
        console.log(counter)
        console.log(cartData)
    }, [counter, priceAmount]);
    // add and delter product Func with summ order



    // Define a callback function
    const orderButtonClick = useCallback(() => {
        // Function logic
        console.log(`Order Success: ${CartContext} `)
        console.log(CartContext._currentValue)
        //Send a request for order processing to the server

    }, []);
    // Memoize the context provider with the callback
    const contextValue = useMemo(() => ({
        cartData,
        delData,
        plusTypeCount,
        minusTypeCount,
        cleanCart,
        orderButtonClick,
    }), [counter, cleanCart]);
    return (
        <OrderContext.Provider value={contextValue}>
            {children}
        </OrderContext.Provider>
    );
}
export default OrderProvider;